export default {
	IMAGE: 'image',
	VIDEO: 'video',
	YOUTUBE: 'youtube',
	PDF: 'pdf',
	AUDIO: 'audio',
	WEBPAGE: 'webpage',
	AUDIO_RECORDER: 'audio_recorder',
	NONE: 'none',
}
